'use strict'

import { apiInstance } from './index'
import { mapArgs } from 'utils/functions'

const billing = {
  getOpenInvoice (companyId) {
    return apiInstance({
      method: 'GET',
      url: `/b2b-wallet-app/order/preview/summary/${companyId}`
    })
  },

  getRefundsList (...args) {
    const params = mapArgs(...args)
    return apiInstance({
      method: 'GET',
      url: '/b2b-wallet-app/order',
      params
    })
  },

  getRefundSummary (id) {
    return apiInstance({
      method: 'GET',
      url: `/b2b-wallet-app/order/${id}/v2/summary`
    })
  },

  getRefundReceipts (id, ...args) {
    const params = mapArgs(...args)
    return apiInstance({
      method: 'GET',
      url: `/b2b-wallet-app/order/${id}/receipts`,
      params
    })
  },

  getOpenInvoiceReceipts (...args) {
    const params = mapArgs(...args)
    return apiInstance({
      method: 'GET',
      url: '/b2b-wallet-app/order/preview/rideServiceReceipts',
      params
    })
  },

  getCreditCardData (financialAccountId) {
    return apiInstance({
      method: 'GET',
      url: `/b2b-wallet-app/financialAccount/${financialAccountId}/creditCard`
    })
  },

  // DOING
  changeCreditCard (data) {
    return apiInstance({
      method: 'PUT',
      url: `/b2b-wallet-app/financialAccount/${data.companyId}/paymentMethod`,
      data
    })
  },

  uploadNfe (formData) {
    return apiInstance({
      method: 'POST',
      url: '/b2b-wallet-app/order/nfe/upload',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData
    })
  },

  getReprocessCreditCardInvoices (...args) {
    const params = mapArgs(...args)
    return apiInstance({
      method: 'GET',
      url: '/b2b-wallet-app/order/reprocess',
      params
    })
  },

  reprocessCreditCardInvoiceMassive (data) {
    return apiInstance({
      method: 'PUT',
      url: '/b2b-wallet-app/order/reprocess/massive',
      data
    })
  },

  reprocessCreditCardInvoiceByPeriod (data) {
    return apiInstance({
      method: 'PUT',
      url: '/b2b-wallet-app/order/reprocess/period',
      data
    })
  },

  getFinancialSummary (...args) {
    const params = mapArgs(...args)
    return apiInstance({
      method: 'GET',
      url: '/b2b-wallet-app/financesummary',
      params
    })
  },

  // chargeback (consulta a corrida) aplicar crédito e estorno
  searchApiTaxiJobId (id, ...args) {
    const params = mapArgs(...args)
    return apiInstance({
      method: 'GET',
      url: `/b2b-wallet-app/serviceReceipt/ride/apiTaxiJobId/${id}`,
      params
    })
  },

  // ============================================================
  // CHARGEBACK
  // ============================================================

  getChargeBackList (...args) {
    // financialAccountId (para filtrar por empresa)
    const params = mapArgs(...args)
    return apiInstance({
      method: 'GET',
      url: '/b2b-wallet-app/chargeBack',
      params
    })
  },

  createChargeBack (data) {
    /**
     {
       "serviceReceiptId": "{{serviceReceiptId}}",
       "value": "35.90",
       "reason": "creating"
     }
     */
    return apiInstance({
      method: 'POST',
      url: '/b2b-wallet-app/chargeBack',
      data
    })
  },

  updateChargeBack (chargeBackId, data) {
    /**
    {
      "reason": "Estorno integral da corrida",
      "value": 0
    }
     */
    return apiInstance({
      method: 'PUT',
      url: `/b2b-wallet-app/chargeBack/${chargeBackId}`,
      data
    })
  },

  cancelChargeBack (chargeBackId, data) {
    // logically delete by putting status CANCELED
    return apiInstance({
      method: 'DELETE',
      url: `/b2b-wallet-app/chargeBack/${chargeBackId}`,
      data
    })
  },

  denyChargeBack (chargeBackId) {
    // putting status DENIED (DO NOT USE)
    return apiInstance({
      method: 'PUT',
      url: `/b2b-wallet-app/chargeBack/${chargeBackId}/deny`
    })
  },

  // ============================================================
  // CREDIT
  // ============================================================

  getCreditList (...args) {
    // financialAccountId (para filtrar por empresa)
    const params = mapArgs(...args)
    return apiInstance({
      method: 'GET',
      url: `/b2b-wallet-app/credit/balance`,
      params
    })
  },

  getCreditById (apiTaxiJobId) {
    return apiInstance({
      method: 'GET',
      url: `/b2b-wallet-app/credit/apiTaxiJobId/${apiTaxiJobId}`,
      data: {} // TO DO
    })
  },

  createCredit (serviceReceiptId, data) {
    /**
    {
      "value": 16.01,
      "reason": "Crédito aprovado pelo financeiro."
    }
     */
    return apiInstance({
      method: 'POST',
      url: `/b2b-wallet-app/serviceReceipt/${serviceReceiptId}/credit`,
      data
    })
  },

  updateCredit (serviceReceiptId, data) {
    /**
    {
      "value": 16.01,
      "reason": "Crédito aprovado pelo financeiro."
    }
     */
    return apiInstance({
      method: 'PUT',
      url: `/b2b-wallet-app/credit/${serviceReceiptId}`,
      data
    })
  },

  cancelCredit (creditId) {
    return apiInstance({
      method: 'DELETE',
      url: `/b2b-wallet-app/credit/${creditId}`
    })
  },

  // get credit (credito da corrida)
  // https://b2b-gateway.99app.com/b2b-wallet-app/credit/apiTaxiJobId/{{apiTaxiJobId}}

  // DISCOUNT

  // GET - /b2b-wallet-app/companyId/:companyId/discount
  getDiscountByCompany (companyId, ...args) {
    const params = mapArgs(...args)
    return apiInstance({
      method: 'GET',
      url: `/b2b-wallet-app/companyId/${companyId}/discount`,
      params
    })
  },

  // POST - /b2b-wallet-app/companyId/:companyId/discount

  /**
  {
    "expirationDate": "2020-12-01",
    "reason": "teste ",
    "unit": "PERCENT", / RAW_VALUE
    "value": 10
  }
   */
  createDiscount (companyId, data) {
    return apiInstance({
      method: 'POST',
      url: `/b2b-wallet-app/companyId/${companyId}/discount`,
      data
    })
  },

  // PUT - /b2b-wallet-app/companyId/:companyId/discount/:discountId
  /**
    {
      "expirationDate": "2020-11-01",
      "startDate": "2020-03-26",
      "reason": "teste ",
      "unit": "PERCENT",
      "serviceContractId": "5e7cff1c6a0c61000103421b",
      "enabled":true,
      "value": 10
    }
    */
  updateDiscount (companyId, discountId, data) {
    return apiInstance({
      method: 'PUT',
      url: `/b2b-wallet-app/companyId/${companyId}/discount/${discountId}`,
      data
    })
  },

  // DELETE - /b2b-wallet-app/companyId/:companyId/discount/:discountId
  cancelDiscount (companyId, discountId) {
    return apiInstance({
      method: 'DELETE',
      url: `/b2b-wallet-app/company/${companyId}/discount/${discountId}`
    })
  },

  getDiscounts (companyId) {
    return apiInstance({
      method: 'GET',
      url: `/b2b-wallet-app/company/${companyId}/discount`
    })
  },

  setDiscount (companyId, data) {
    return apiInstance({
      method: 'POST',
      url: `/b2b-wallet-app/company/${companyId}/discounts`,
      data
    })
  },

  getDuplicateOrder (invoiceId, ...args) {
    const params = mapArgs(...args)
    return apiInstance({
      method: 'GET',
      url: `/b2b-wallet-app/order/${invoiceId}/duplicate`,
      params
    })
  },

  createDuplicateOrder (invoiceId, data) {
    return apiInstance({
      method: 'POST',
      url: `/b2b-wallet-app/order/${invoiceId}/duplicate`,
      data
    })
  },

  updateEmailsToNotify (id, data) {
    return apiInstance({
      method: 'PUT',
      url: `/b2b-wallet-app/financialAccount/${id}/emailsToNotify`,
      data
    })
  },

  updateMassiveOrder (companyId, data) {
    return apiInstance({
      method: 'POST',
      url: `/b2b-wallet-app/massive/order/upload/${companyId}`,
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 60000,
      data
    })
  },

  executeMassiveOrder (massiveId) {
    return apiInstance({
      method: 'POST',
      url: `/b2b-wallet-app/massive/order/execute/${massiveId}`
    })
  },

  getOrdersByFilter (...args) {
    const params = mapArgs(...args)
    return apiInstance({
      method: 'GET',
      url: '/b2b-wallet-app/order/filter',
      params
    })
  },

  getMassiveWorkerProcess (...args) {
    const params = mapArgs(...args)
    return apiInstance({
      method: 'GET',
      url: '/b2b-wallet-app/massive/order',
      params
    })
  },

  updateOrderStatus (numericalId, data) {
    return apiInstance({
      method: 'PATCH',
      url: `/b2b-wallet-app/order/${numericalId}/payment/status`,
      data
    })
  }
}

export default billing
